import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VContainer,
    { attrs: { fluid: "", "grid-list-xl": "" } },
    [
      _c("app-monitoramento", {
        attrs: {
          acesso: _vm.acesso,
          monitoramento: "mapeamento",
          titulo: "Estrutura das Unidades",
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  VCol,
                  { attrs: { centered: "", cols: "12", "no-gutters": "" } },
                  [
                    _c(
                      VRow,
                      { staticClass: "justify-center ma-2" },
                      [
                        _c(
                          VTabs,
                          {
                            attrs: { centered: "", "icons-and-text": "" },
                            model: {
                              value: _vm.categoria,
                              callback: function ($$v) {
                                _vm.categoria = $$v
                              },
                              expression: "categoria",
                            },
                          },
                          [
                            _c(VTabsSlider, {
                              attrs: { color: "secondary" },
                            }),
                            _vm._l(_vm.categorias.length, function (i) {
                              return _c(
                                VTab,
                                {
                                  key: i,
                                  staticClass: "mt-3",
                                  attrs: {
                                    href: "#" + _vm.categorias[i - 1].id,
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "grey--text text--darken-2",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.categorias[i - 1].descricao)
                                      ),
                                    ]
                                  ),
                                  _c(
                                    VIcon,
                                    {
                                      attrs: {
                                        color:
                                          _vm.categorias[i - 1].id ===
                                          _vm.categoria
                                            ? "secondary"
                                            : "grey",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.categorias[i - 1].icone) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            }),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                    _c(
                      VRow,
                      { staticClass: "justify-center ma-2" },
                      [
                        _c(
                          "keep-alive",
                          [
                            _c(_vm.currentComponent, {
                              key: _vm.currentComponentKey,
                              tag: "component",
                              attrs: { mapeamento: _vm.mapeamento },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }